<page-header
  [title]="constants.strings.assets"
  [subtitle]="subtitle"
></page-header>

<div style="margin-top: 20px" *ngIf="!guidesLoading">
  <div
    style="
      background-color: var(--app-container);
      border-radius: 10px;
      padding: 20px;
    "
  >
    <p
      class="section-title"
      style="font-weight: 500; font-size: 16px; margin-bottom: 0px"
    >
      Printable Maketing Assets
    </p>
    <p
      class="section-title"
      style="
        font-weight: normal;
        color: grey;
        font-size: 14px;
        margin-bottom: 10px;
      "
    >
      Feel free to use these assets to promote your loyalty cards and Remy
      Rewards. For our logos and other assets, please refer to
      <span
        ><a
          target="_blank"
          href="https://drive.google.com/drive/folders/1om5aOul_vW-CMWLvaCoMzikRrmLobXT3?usp=drive_link"
          >this link</a
        ></span
      >
    </p>

    <div class="thumbnail-container">
      <div
        class="thumbnail"
        *ngFor="let guide of guides; let i = index"
        (click)="open(guide)"
      >
        <div class="img-container">
          <img [src]="getThumbnailUrl(guide)" [alt]="guide.title" />
        </div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
          "
        >
          <div class="thumbnail-title">
            {{ guide.title }}
          </div>
          <mat-icon
            style="
              color: var(--app-timber);
              font-size: 16px;
              display: flex;
              align-items: center;
            "
          >
            arrow_forward_ios</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
</div>

<loader [loading]="loading"></loader>
